"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _Application = _interopRequireDefault(require("./containers/Application"));

var _Home = _interopRequireDefault(require("./containers/Home"));

// Only import and use 'containers' for your route handlers
var _default = _react.default.createElement(_reactRouter.Route, {
  path: "/",
  component: _Application.default
}, _react.default.createElement(_reactRouter.IndexRoute, {
  component: _Home.default
}));

exports.default = _default;
module.exports = exports.default;